module.exports = __webpack_public_path__ + "static/media/sel-l.9f6b8e43.mp3";